import React from 'react';
import CarouselNosotros from '../components/carouselNosotros';

import FloatingButton from '../components/buttonFlotanteWha';
import imagenTrabajador from "../assets/images/about_client.jpg"
import CardInfo from '../components/cardInfo';
import Mision from "../assets/images/mision1.png"
import Vision from "../assets/images/valores.png"
import Valores from "../assets/images/vision.png"
import CardNosotros from '../components/cardNosotros';
import "./styles.css"
import Banner from '../components/banner';
import Imagen1 from "../assets/images/nosotros/1.png"
import Imagen2 from "../assets/images/nosotros/2.png"
import Imagen3 from "../assets/images/nosotros/3.png"
import Imagen4 from "../assets/images/nosotros/4.png"
import Distincion from '../components/distincion';
import B1 from "../assets/images/cap/banner/2.png"
import B2 from "../assets/images/cap/banner/3.png"
import B3 from "../assets/images/cap/banner/4.png"
import B6 from "../assets/images/cap/banner/5.png"
import B4 from "../assets/images/cap/banner/6.png"
import B5 from "../assets/images/cap/banner/7.png"
import B7 from "../assets/images/cap/banner/8.png"
import B8 from "../assets/images/cap/banner/9.png"




function Nosotros(){
    return(
       <div className="animated-background">
         <div className="flex flex-col items-center p-10  space-y-10">
         <CarouselNosotros />

         {/* Nosotros*/}
         <div className='flex flex-col items-center text-center w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
              Nosotros
            </h1>
            <div className='bg-oro h-1 w-32 my-3'></div>
            <p className='text-gris-oscuro font-medium text-lg'>
            CECOMP TRAINING. Busca establecer una estrecha relación con sus clientes con la finalidad de satisfacer sus necesidades y detectar oportunidades de mejora para su empresa y su personal.
            </p>
          </div>
          
          {/* Content Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-center w-full max-w-6xl mx-auto px-6 md:px-0">
  {/* Imagen del Trabajador */}
  <div className="flex justify-center">
    <img
      src={imagenTrabajador}
      alt="Trabajador"
      className="w-80 h-80 object-cover rounded-lg shadow-xl hover:scale-105 transition-transform duration-500 border-4 border-oro"
    />
  </div>

  {/* Contenido de "Quiénes Somos" */}
  <div>
    <h1 className="text-azul-oscuro text-2xl md:text-2xl uppercase font-extrabold mb-3 hover:text-oro duration-300">
      ¿Quiénes Somos?
    </h1>
    <div className="bg-oro h-1 w-32 md:w-48 mb-4"></div>
    
    <p className="text-gris-oscuro text-lg leading-relaxed tracking-wide text-justify">
      Somos una empresa peruana con operaciones a nivel internacional, especializada en Consultoría, Asesoría Técnica, 
      Capacitación, Inspección y Certificación. Cumplimos estrictamente con normativas nacionales e internacionales como 
      ASME, ANSI, AWS, BSI, DIN, ISO, OSHA, y en Perú con el DS.023EM-2017 y la Ley 29783.
    </p>
    <p className="text-gris-oscuro text-lg leading-relaxed tracking-wide mt-4 text-justify">
      Somos pioneros en programas de capacitación para <strong>FORMAR, ENTRENAR Y CERTIFICAR OPERADORES</strong>  de maquinaria pesada y grúas industriales, 
      dirigidos a técnicos, supervisores, instructores y comunidades cercanas a proyectos mineros. Brindamos formación en <strong>seguridad industrial, 
      seguridad operacional, calidad y correcta operación de equipos</strong>.
    </p>
    <p className="text-gris-oscuro text-lg leading-relaxed tracking-wide mt-4 text-justify">
      Nuestro equipo humano cuenta con <strong>amplia experiencia y compromiso con los principios y valores de CECOMP TRAINING. </strong> 
      Cumplimos las normativas vigentes y nos enfocamos en trabajo seguro, ofreciendo un servicio <strong>personalizado y profesional </strong>  
      adaptado a las necesidades de cada cliente.
    </p>
  </div>
</div>


          <div className='flex flex-col text-left w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
            NUESTRO PRESENTE
            </h1>
            <div className='bg-oro h-1 w-60 my-3'></div>
            <p className='font-medium text-lg text-justify'>
            Somos líderes en Certificación de Grúas Industriales, Maquinaria pesada, sus operadores y Ayudantes a nivel mundial Avalamos Certificaciones de Herramientas y Equipos de Izáje respetando puntualmente las normas internacionales y locales de cada país donde Cecomp Training Opera así como los lineamientos y especificaciones establecidos por la industria.
            </p>
          </div >
           

           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 w-full max-w-7xl px-4"> 
            <CardInfo
            imagen={Mision}
            titulo="Misión"
            descripcion="Ser la empresa líder en el mercado Nacional e Internacional dedicado a la Formación; Capacitación; Entrenamiento y Certificación de colaboradores operativos en minería, petróleo, industria y construcción."/>

            <CardInfo
            imagen={Vision}
            titulo="Visión"
            descripcion="Asegurar la Formación, Capacitación, Entrenamiento y Certificación de alta calidad para lograr colaboradores calificados, comprometidos y responsables con la Seguridad, Responsabilidad Social, Medio Ambiente, rentabilidad y productividad."/>

            <CardInfo
            imagen={Valores}
            titulo="Valores"
            descripcion={`🦺Ser Íntegros en nuestros comportamientos.\n🦺 Trabajar con lealtad.\n🦺 Dar confianza.\n🦺 Hablar con la verdad.\n🦺 Velar por nuestros colaboradores.`}/>
            
           </div>

           <div className='flex flex-col text-left w-full'>
           <Banner imagenFondo={Imagen4} imagenesCertificaciones={[B1,B2,B3,B4,B5,B6,B7,B8]}  />

          </div >




           <div className='flex flex-col text-left w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
            Qué hacemos
            </h1>
            <div className='bg-oro h-1 w-60 my-3'></div>
            <p className='font-medium text-lg text-justify'>
            Estamos Orientados a la formación de Operadores Nuevos de Maquinaria Pesada, Grúas industriales, ayudantes, Rigeer, así como a la Actualización, capacitación. Evaluación, certificación. Cecomp Training es una empresa autorizada a nivel internacional para llevar acabo las diferentes actividades de capacitación, certificación, consultoría, Inspección. En los diversos sectores de la industria, Minería cielo abierto, Minería subterránea, petrolera, marítima, perforaciones.
            </p>
          </div >
           

           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 w-full max-w-7xl px-4"> 
          
            <CardNosotros 
            image={Imagen1}
            title="ACTIVIDAD PRINCIPAL"
            description="Conscientes de la importancia que tiene la Capacitación, Certificación, inspección. Tanto de Equipo Pesado de la Minería y construcción, Maquinaria Industrial como de Operadores, Supervisores y Rigeer. Es necesario seguir los procedimientos claramente establecidos, alineados a las normativas existentes, con el respaldo de la experiencia adquirida por un capital humano de especialistas, ingenieros, técnicos."/>
             <CardNosotros 
            image={Imagen2}
            title="NUESTRA GENTE"
            description="Nuestro principal valor es el que viene de nuestra gente. Estamos orgullosos de contar con un equipo humano de trabajo altamente capacitado y debidamente certificados Que garantiza el servicio que brindamos y sea el de mayor calidad con un enfoque multifuncional que permita la toma de datos para la mejor operatividad y decisión para el crecimiento de su organización. Contamos con un staff de instructores, ingenieros, técnicos profesionales con una amplia trayectoria y experiencia en las capacitaciones, certificaciones, auditorias, inspecciones"/>
             <CardNosotros 
            image={Imagen3}
            title="COBERTURA"
            description="Tenemos cobertura a nivel internacional ya que estamos trabajando en muchos de los países de América. El nivel de excelencia de nuestros servicios de certificación nos hace en muchos casos la elección preferida por sobre las entidades certificadoras"/>
           </div>



           <div className='flex flex-col text-left w-full'>
            <Distincion/>
          </div >

          
          
           <FloatingButton/>
        </div>
       </div>
    )
}
export default Nosotros;